import { useServiceQueuesState } from './useServiceQueuesState';
import QueuesTable from './QueuesTable/QueuesTable';
import { OutboundCallDetails } from '../types';

interface IOutboundModalQueuesProps {
  setCallDetails: (details: OutboundCallDetails) => void;
}

const OutboundModalQueues: React.FC<IOutboundModalQueuesProps> = ({
  setCallDetails,
}) => {
  const { queues, loading } = useServiceQueuesState();
  return (
    <QueuesTable
      queues={queues}
      loading={loading}
      setCallDetails={setCallDetails}
      initialSort={[{ field: 'estimatedWait', dir: 'asc' }]}
    />
  );
};

export default OutboundModalQueues;
